import React from 'react';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import {useTranslation} from 'react-i18next';
import {useStatusRestriction} from '../../hooks/useStatusRestriction';
import StatusRestrictionMessage from '../../Components/StatusRestrictionMessage/StatusRestrictionMessage';
import MovementProductsTable from './tables/MovementProductsTable';
import GoodsMovementTable from './tables/GoodsMovementTable';

const ProductReport = () => {
	const {t} = useTranslation();
	const restrictions = useStatusRestriction();

	if (!restrictions.canAccessWarehouseSection) {
		return (
			<div className="page__content">
				<StatusRestrictionMessage message={t('Сторінка недоступна')} />
			</div>
		);
	}

	return (
		<div className="page__content">
			<TopTitleBlock title={t('Товарний звіт')} />
			{/*<BalanceProductsTable />*/}
			<MovementProductsTable />
			<GoodsMovementTable />
		</div>
	);
};

export default ProductReport;
